import { useInView } from './hooks';

const ic = d => <svg viewBox="0 0 24 24" aria-hidden="true">{d}</svg>;
const LOCK = ic(<><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 018 0v3" /></>);
const GUARDS = [
  ['Komut doğrulama', 'Her komut, işlenmeden önce kontrol edilir; zararlı veya yönlendirici talepler ayıklanır.', ic(<><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" /><path d="M9 12l2.2 2.2L15.5 10" /></>)],
  ['En az yetki', 'Ajan yalnızca görevi için gereken kaynağa, salt okunur erişir.', ic(<><circle cx="8" cy="12" r="3.2" /><path d="M11 12h9M17 12v3M14.5 12v2" /></>)],
  ['Onaylı yazma', 'ERP’ye yazma ve dışa gönderim, kullanıcı onayı olmadan gerçekleşmez.', ic(<><circle cx="12" cy="12" r="8.5" /><path d="M8.5 12.2l2.4 2.4 4.6-5" /></>)],
  ['Davranış izleme', 'Ajanın sıra dışı davranışı algılanır; şüpheli işlem durdurulur.', ic(<><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" /><circle cx="12" cy="12" r="2.8" /></>)],
  ['Denetim kaydı', 'Komut, adım ve sonuç zaman damgasıyla kaydedilir.', ic(<><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4M10 12h5M10 16h5" /></>)]
];
const OPTIONS = [
  ['On-prem kurulum', 'VİZOVA şirketinizin kendi sunucusunda, kendi ağınızın içinde çalışabilir.', ic(<><rect x="4" y="4" width="16" height="6" rx="1.5" /><rect x="4" y="14" width="16" height="6" rx="1.5" /><path d="M8 7h.01M8 17h.01" /></>)],
  ['Yerel yapay zekâ', 'Yapay zekâ modeli yerelde çalıştırılabilir; komutlar ve veriler dış servise gönderilmez.', ic(<><rect x="6" y="6" width="12" height="12" rx="2" /><path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" /></>)],
  ['Yerel hosting', 'Tercihe göre özel sunucu veya yerel veri merkezinde barındırma seçeneği sunulur.', ic(<><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10M10 20v-5h4v5" /></>)]
];

export default function SecurityDiagram() {
  const [ref, seen] = useInView(0.15);
  return (
    <div ref={ref} className={'sc' + (seen ? ' in' : '')}>
      <div className="sc-stage">
        <div className="sc-zone">
          <div className="sc-zone-tag">{LOCK}<span>Şirket ağı · On-prem</span></div>

          <div className="sc-flow">
            <div className="sc-box" style={{ '--i': 0 }}>
              <div className="sc-cap">Veri kaynakları</div>
              <div className="sc-pill"><i style={{ background: '#1F4E9A' }}>SAP</i>SAP</div>
              <div className="sc-pill"><i style={{ background: '#C8102E' }}>LOGO</i>Logo ERP</div>
              <div className="sc-pill"><i style={{ background: '#107C41' }}>X</i>Excel · ofis / şube PC</div>
            </div>
            <div className="sc-arrow" aria-hidden="true"><span /></div>
            <div className="sc-box sc-core" style={{ '--i': 1 }}>
              <div className="sc-core-logo">
                <svg viewBox="0 0 100 100" aria-hidden="true"><polygon points="4,6 30,6 50,78 70,6 96,6 61,100 39,100" fill="#D0202E" /><polygon points="50,78 61,100 39,100" fill="#96101C" /></svg>
                <b>VİZOVA</b>
              </div>
              <div className="sc-chip red">Yerel yapay zekâ modeli</div>
              <div className="sc-chip">Yerel hosting</div>
            </div>
            <div className="sc-arrow" aria-hidden="true"><span /></div>
            <div className="sc-box" style={{ '--i': 2 }}>
              <div className="sc-cap">Kontrollü çıktı</div>
              <div className="sc-pill"><i className="num-i">1</i>Kullanıcı onayı</div>
              <div className="sc-pill"><i className="num-i">2</i>Teklif PDF’i</div>
              <div className="sc-pill"><i className="num-i">3</i>Denetim kaydı</div>
            </div>
          </div>

          <div className="sc-band">
            <div className="sc-band-h">{GUARDS[0][2]}<b>Agentic siber güvenlik katmanı</b><span>Ajanın her adımı bu katmandan geçer</span></div>
            <div className="sc-guards">
              {GUARDS.map(([t, d, icon], i) => (
                <div key={t} className="sc-guard" style={{ '--i': i }}>
                  <span className="sc-gi">{icon}</span><b>{t}</b><small>{d}</small>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="sc-out" aria-hidden="true">
          <div className="sc-block"><span /><i>✕</i></div>
          <div className="sc-cloud">
            <svg viewBox="0 0 24 24"><path d="M7 18a4.5 4.5 0 01-.6-8.96A6 6 0 0118 10.5 3.8 3.8 0 0117.5 18z" /></svg>
            <b>Dış bulut / internet</b>
            <small>Veri çıkışı yok</small>
          </div>
        </div>
      </div>

      <div className="sc-opts">
        {OPTIONS.map(([t, d, icon], i) => (
          <div key={t} className="sc-opt" style={{ '--i': i }}>
            <span className="sc-oi">{icon}</span>
            <b>{t}</b>
            <p>{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
